import { render, staticRenderFns } from "./TechnicalReports.vue?vue&type=template&id=69971946&scoped=true"
import script from "./TechnicalReports.vue?vue&type=script&lang=js"
export * from "./TechnicalReports.vue?vue&type=script&lang=js"
import style0 from "./TechnicalReports.vue?vue&type=style&index=0&id=69971946&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69971946",
  null
  
)

export default component.exports